import { Col, Row } from "react-bootstrap";
import "./offerJobForm.css";
import Form from "react-bootstrap/Form";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import BackArrow from "../../backArrow";
import { useState, useEffect } from "react";
import { FailedNotify, SuccessNotify } from "../../../constants/tostify";
import { useSelector } from "react-redux";
import Loader from "../../Loader";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  useGetCompanyByIdQuery,
  useGetJobByIdQuery,
  useCreateJobMutation,
  useUpdateJobMutation,
} from "../../../features/user/userApiSlice";
import {
  useLazyGetShopCategoriesQuery,
  useGetWorldCitiesQuery,
} from "../../../features/shop/shopApiSlice";
import { decodeId } from "../../../utils/idObfuscator";

const OfferJobForm = (props) => {
  const { name } = useSelector((state) => state.user);
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const cleanId = decodeId(id) || id || "";
  const isUpdateMode = location.pathname === `/update-job/${id}` || location.pathname === `/update-job/${cleanId}`;

  // ----------- Country / State / City -----------
  const { data: worldCitiesData } = useGetWorldCitiesQuery();
  const countrydata = worldCitiesData || [];
  const [getState, setState] = useState([]);
  const [getcity, setGetcity] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedstateone, setSelectedstateone] = useState("");
  const [selectedcity, setSelectedcity] = useState("");
  const [hidefield] = useState(1);

  // ----------- Category selectors -----------
  const [jobdataone, SetJobdataone] = useState({ categoryid: "", title: "" });
  const [jobdatatwo, SetJobdatatwo] = useState({ subCategoryid: "" });

  const [shopCategory, setShopCategory] = useState([]);
  const [jobcategory, SetJobcategory] = useState([]);
  const [jobcategorytwo, SetJobcategorytwo] = useState([]);

  // RTK Lazy queries for categories
  const [fetchMainCategories] = useLazyGetShopCategoriesQuery();
  const [fetchSubCategories] = useLazyGetShopCategoriesQuery();
  const [fetchSubSubCategories] = useLazyGetShopCategoriesQuery();

  const jobtitle = jobdataone?.title[1];
  const jobtitleid = jobdataone?.title[0];
  const categoryName = jobdataone?.categoryid[1];
  const categoryidtwo = jobdataone?.categoryid[0];
  const subcategoryName = jobdatatwo?.subCategoryid[1];
  const subcategoryidtwo = jobdatatwo?.subCategoryid[0];

  // ----------- Job form state -----------
  const [jobdata, setJobdata] = useState({
    companyId: id,
    title: "",
    companyname: "",
    category: "",
    categoryid: "",
    subCategoryid: "",
    subCategory: "",
    country: "",
    state: "",
    city: "",
    duration: "",
    jobtype: "",
    siteremote: "",
    description: "",
    email: "",
    contact: "",
    businessType: "jobsCompany",
  });

  // ----------- RTK Query: company & job data -----------
  const { data: companyResponse } = useGetCompanyByIdQuery(cleanId, { skip: !cleanId });
  const companydata = companyResponse?.data?.Company;

  const { data: jobResponse } = useGetJobByIdQuery(cleanId, {
    skip: !cleanId || !isUpdateMode,
  });

  // Populate job data on update mode
  useEffect(() => {
    if (isUpdateMode && jobResponse?.data?.job) {
      setJobdata(jobResponse.data.job);
    }
  }, [isUpdateMode, jobResponse]);

  // Sync category selections into jobdata
  useEffect(() => {
    setJobdata((prev) => ({
      ...prev,
      categoryid: categoryidtwo !== undefined ? categoryidtwo : prev.categoryid,
      category: categoryName !== undefined ? categoryName : prev.category,
      subCategoryid: subcategoryidtwo !== undefined ? subcategoryidtwo : prev.subCategoryid,
      subCategory: subcategoryName !== undefined ? subcategoryName : prev.subCategory,
      title: jobtitle !== undefined ? jobtitle : prev.title,
    }));
  }, [categoryidtwo, categoryName, subcategoryidtwo, subcategoryName, jobtitle]);

  // Set company name from fetched companydata only if not already set
  useEffect(() => {
    if (!isUpdateMode && companydata?.companyname) {
      setJobdata((prev) => ({
        ...prev,
        companyname: prev.companyname || companydata.companyname,
      }));
    }
  }, [companydata, isUpdateMode]);

  // ----------- Category click handlers -----------
  const Mydataone = async () => {
    try {
      const res = await fetchMainCategories({ type: "jobs", parentCategory: "" }).unwrap();
      if (res?.success) setShopCategory(res?.data?.Category || []);
    } catch (_) {}
  };

  const Mydatatwo = async () => {
    if (!jobtitle) return;
    try {
      const res = await fetchSubCategories({ type: "jobs", parentCategory: jobtitle }).unwrap();
      if (res?.success) SetJobcategory(res?.data?.Category || []);
    } catch (_) {}
  };

  const Mydatathree = async () => {
    if (!categoryName) return;
    try {
      const res = await fetchSubSubCategories({ type: "jobSubItem", parentCategory: categoryName }).unwrap();
      if (res?.success) SetJobcategorytwo(res?.data?.Category || []);
    } catch (_) {}
  };

  // ----------- Handlers -----------
  const Handlejobdata = (e) => {
    SetJobdataone((prev) => ({ ...prev, [e.target.name]: e.target.value.split(".") }));
  };
  const Handlejobdatatwo = (e) => {
    SetJobdatatwo((prev) => ({ ...prev, [e.target.name]: e.target.value.split(".") }));
  };
  const JobHandler = (event) => {
    setJobdata((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  // ----------- Country / State / City -----------
  const country = [...new Set(countrydata.map((item) => item.country))].filter(Boolean).sort();

  // Sync location from backend API companydata / Redux user
  useEffect(() => {
    if (isUpdateMode) return;
    const defaultCountry =
      companydata?.resolvedCountry ||
      companydata?.country ||
      companydata?.userid?.address?.country ||
      companydata?.userid?.country ||
      name?.address?.country ||
      name?.country ||
      "";
    const defaultState =
      companydata?.resolvedRegion ||
      companydata?.state ||
      companydata?.userid?.address?.state ||
      companydata?.userid?.state ||
      name?.address?.state ||
      name?.state ||
      "";
    const defaultCity =
      companydata?.resolvedCity ||
      companydata?.city ||
      companydata?.userid?.address?.city ||
      companydata?.userid?.city ||
      name?.address?.city ||
      name?.city ||
      name?.MCity ||
      "";

    if (defaultCountry && !selectedCountry) setSelectedCountry(defaultCountry);
    if (defaultState && !selectedstateone) setSelectedstateone(defaultState);
    if (defaultCity && !selectedcity) setSelectedcity(defaultCity);

    setJobdata((prev) => ({
      ...prev,
      companyId: prev.companyId || companydata?._id || cleanId || id,
      country: prev.country || defaultCountry,
      state: prev.state || defaultState,
      city: prev.city || defaultCity,
    }));
  }, [companydata, name, cleanId, id, isUpdateMode]);

  // Synchronize state options whenever selectedCountry or countrydata changes
  useEffect(() => {
    if (selectedCountry && countrydata.length > 0) {
      let states = countrydata.filter(
        (item) => item.country === selectedCountry,
      );
      states = [...new Set(states.map((item) => item.subcountry))].filter(
        Boolean,
      );
      states.sort();
      setState(states);
    } else if (!selectedCountry) {
      setState([]);
    }
  }, [selectedCountry, countrydata]);

  // Synchronize city options whenever selectedstateone or countrydata changes
  useEffect(() => {
    if (selectedstateone && countrydata.length > 0) {
      let cities = countrydata.filter(
        (item) => item.subcountry === selectedstateone,
      );
      setGetcity(cities);
    } else if (!selectedstateone) {
      setGetcity([]);
    }
  }, [selectedstateone, countrydata]);

  // ----------- RTK Mutations -----------
  const [createJobMutation, { isLoading: isCreating }] = useCreateJobMutation();
  const [updateJobMutation, { isLoading: isUpdating }] = useUpdateJobMutation();

  const isloading = isCreating || isUpdating;

  const PostData = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...jobdata,
        companyId: jobdata.companyId || companydata?._id || cleanId || id,
        country: jobdata.country || selectedCountry,
        state: jobdata.state || selectedstateone,
        city: jobdata.city || selectedcity,
      };
      const response = await createJobMutation(payload).unwrap();
      if (response?.success) {
        setTimeout(() => {
          SuccessNotify("Job Posted Successfully");
          navigate(`/company-profile/${id}`);
        }, 1000);
      }
    } catch (error) {
      const msg = error?.data?.message || error?.message || "Failed to post job";
      FailedNotify(msg);
    }
  };

  const updateData = async (e) => {
    e.preventDefault();
    try {
      const response = await updateJobMutation({ id, data: jobdata }).unwrap();
      if (response?.success) {
        setTimeout(() => {
          SuccessNotify("Job Updated Successfully");
          navigate("/job-details/" + id);
        }, 1000);
      }
    } catch (error) {
      const msg = error?.data?.message || error?.message || "Failed to update job";
      FailedNotify(msg);
    }
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("title is required*"),
    country: Yup.string().required("country is required*"),
    state: Yup.string().required("state is required*"),
    city: Yup.string().required("city is required*"),
    description: Yup.string().required("description is required*"),
    email: Yup.string().email("Invalid email").required("Required"),
    contact: Yup.string()
      .matches(/^\d+$/, "Contact must be a number*")
      .required("Contact is required*"),
  });

  if (isloading) {
    return (
      <div>
        <Loader heightsetting="screenHeight" />
      </div>
    );
  }

  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={{
          title: jobdata?.title || "",
          country: selectedCountry || jobdata?.country || "",
          state: selectedstateone || jobdata?.state || "",
          city: selectedcity || jobdata?.city || "",
          duration: jobdata?.duration || "",
          description: jobdata?.description || "",
          email: jobdata?.email || "",
          contact: jobdata?.contact || "",
        }}
        validateOnBlur={false}
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ handleChange, handleBlur, setFieldValue, values, errors, touched }) => (
          <Form>
            <Row>
              <div className="screenHeight d-flex justify-content-center align-items-center">
                <Col lg={9} md={9} className="Form-Shadow">
                  {isUpdateMode ? (
                    <div className="arrowback ps-3">
                      <BackArrow back={`/job-details/${id}`} black="black" mystyle="ps-2 p-1" />
                    </div>
                  ) : (
                    <div className="arrowback ps-3">
                      <BackArrow back={`${props.back}/${id}`} black="black" mystyle="ps-4 p-1" />
                    </div>
                  )}

                  <Row className="pt-3 px-5">
                    {/* Company Name */}
                    <Col md={3} lg={3} xl={3}>
                      <Form.Label id="placeholderClorset" className="custm-lble mt-1">
                        Company Name
                      </Form.Label>
                      <Form.Control
                        className="form-control-seller placeholderClorset"
                        name="companyname"
                        value={jobdata?.companyname || ""}
                        onChange={(e) => { handleChange(e); JobHandler(e); }}
                        onBlur={handleBlur}
                      />
                    </Col>

                    {/* Job Title */}
                    <Col md={3} lg={3} xl={3}>
                      <Form.Label className="custm-lble">Job Title</Form.Label>
                      <Form.Select
                        className="form-select-seller"
                        name="title"
                        onChange={(e) => { handleChange(e); Handlejobdata(e); }}
                        onClick={Mydataone}
                        onBlur={handleBlur}
                      >
                        {jobdata?.title?.length > 0
                          ? <option>{jobdata?.title}</option>
                          : <option>Select Title</option>}
                        {shopCategory?.map((cat) => (
                          <option key={cat._id} value={`${cat._id}.${cat.name}`}>
                            {cat.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>

                    {/* Job Category */}
                    <Col md={3} lg={3} xl={3}>
                      <Form.Label className="custm-lble">Job Category</Form.Label>
                      <Form.Select
                        className="form-select-seller"
                        name="categoryid"
                        onChange={(e) => Handlejobdata(e)}
                        onClick={Mydatatwo}
                      >
                        {jobdata?.category?.length > 0
                          ? <option>{jobdata?.category}</option>
                          : <option>job category</option>}
                        {jobcategory?.map((cat) => (
                          <option key={cat._id} value={`${cat._id}.${cat.name}`}>
                            {cat.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>

                    {/* Job Sub-Category */}
                    <Col md={3} lg={3} xl={3}>
                      <Form.Label className="custm-lble">Job Sub-Category</Form.Label>
                      <Form.Select
                        className="form-select-seller"
                        name="subCategoryid"
                        onChange={(e) => { JobHandler(e); Handlejobdatatwo(e); }}
                        onClick={Mydatathree}
                      >
                        {jobdata?.subCategory?.length > 0
                          ? <option>{jobdata?.subCategory}</option>
                          : <option>job sub category</option>}
                        {jobcategorytwo?.map((sub) => (
                          <option key={sub._id} value={`${sub._id}.${sub.name}`}>
                            {sub.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>

                  <Row className="pt-3 pb-2 px-5">
                    {/* Last Date */}
                    <Col md={3} lg={3} xl={3}>
                      <Form.Label className="custm-lble mt-1">Last Date Of Apply</Form.Label>
                      <Form.Control
                        placeholder="Last Date Of Apply"
                        className="form-control-seller placeholderClorset"
                        name="duration"
                        onChange={(e) => { handleChange(e); JobHandler(e); }}
                        onBlur={handleBlur}
                      />
                      {errors.duration && touched.duration && (
                        <p className="error_text_color">{errors.duration}</p>
                      )}
                    </Col>

                    {/* Country */}
                    <Col md={3} lg={3} xl={3}>
                      <Form.Label className="custm-lble">Country*</Form.Label>
                      <Form.Select
                        className="form-select-seller"
                        name="country"
                        value={selectedCountry || values.country || ""}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSelectedCountry(val);
                          setSelectedstateone("");
                          setSelectedcity("");
                          setJobdata((prev) => ({
                            ...prev,
                            country: val,
                            state: "",
                            city: "",
                          }));
                          handleChange(e);
                          setFieldValue("country", val);
                          setFieldValue("state", "");
                          setFieldValue("city", "");
                        }}
                        onBlur={handleBlur}
                      >
                        <option value="">Select-Country</option>
                        {country.map((c) => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </Form.Select>
                      {errors.country && touched.country && (
                        <p className="error_text_color">{errors.country}</p>
                      )}
                    </Col>

                    {/* State */}
                    <Col md={3} lg={3} xl={3}>
                      <Form.Label className="custm-lble">State*</Form.Label>
                      <Form.Select
                        className="form-select-seller"
                        name="state"
                        value={selectedstateone || values.state || ""}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSelectedstateone(val);
                          setSelectedcity("");
                          setJobdata((prev) => ({
                            ...prev,
                            state: val,
                            city: "",
                          }));
                          handleChange(e);
                          setFieldValue("state", val);
                          setFieldValue("city", "");
                        }}
                        onBlur={handleBlur}
                      >
                        <option value="">Select-State</option>
                        {getState.map((s) => (
                          <option key={s} value={s}>{s}</option>
                        ))}
                      </Form.Select>
                      {errors.state && touched.state && (
                        <p className="error_text_color">{errors.state}</p>
                      )}
                    </Col>

                    {/* City */}
                    <Col md={3} lg={3} xl={3}>
                      <Form.Label className="custm-lble">City*</Form.Label>
                      <Form.Select
                        className="form-select-seller"
                        name="city"
                        value={selectedcity || values.city || ""}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSelectedcity(val);
                          setJobdata((prev) => ({
                            ...prev,
                            city: val,
                          }));
                          handleChange(e);
                          setFieldValue("city", val);
                        }}
                        onBlur={handleBlur}
                      >
                        <option value="">Select-City</option>
                        {getcity.map((c) => (
                          <option key={c.name} value={c.name}>{c.name}</option>
                        ))}
                      </Form.Select>
                      {errors.city && touched.city && (
                        <p className="error_text_color">{errors.city}</p>
                      )}
                    </Col>
                  </Row>

                  <Row className="pt-0 px-5">
                    {/* Email */}
                    <Col md={3} lg={3} xl={3}>
                      <Form.Label className="custm-lble mt-1">Email</Form.Label>
                      <Form.Control
                        onChange={(e) => { handleChange(e); JobHandler(e); }}
                        onBlur={handleBlur}
                        defaultValue={jobdata?.email}
                        className="form-control-seller"
                        name="email"
                        placeholder="Email"
                      />
                      {errors.email && touched.email && (
                        <p className="error_text_color">{errors.email}</p>
                      )}
                    </Col>
                    {/* Contact */}
                    <Col md={3} lg={3} xl={3}>
                      <Form.Label className="custm-lble mt-1">Contact Number</Form.Label>
                      <Form.Control
                        onChange={(e) => { handleChange(e); JobHandler(e); }}
                        onBlur={handleBlur}
                        defaultValue={jobdata?.contact}
                        className="form-control-seller placeholderClorset"
                        name="contact"
                        placeholder="Contact Number"
                      />
                      {errors.contact && touched.contact && (
                        <p className="error_text_color">{errors.contact}</p>
                      )}
                    </Col>
                  </Row>

                  <div className="d-flex px-5">
                    {/* Post Duration */}
                    <div className="pe-0 me-3">
                      <Form.Label className="custm-lble" style={{ color: "#0d6efd" }}>
                        Post Duration
                      </Form.Label>
                      <Form>
                        {["radio"].map((type) => (
                          <div key={`inline-${type}`} className="mb-2">
                            {["7 days", "14 days", "1 month"].map((dur, i) => (
                              <div key={dur}>
                                <Form.Check
                                  inline
                                  label={dur}
                                  name="duration"
                                  value={dur}
                                  type={type}
                                  id={`duration-${i}`}
                                  className="labelText2"
                                  onChange={JobHandler}
                                  checked={jobdata?.duration === dur}
                                />
                              </div>
                            ))}
                          </div>
                        ))}
                      </Form>
                    </div>

                    {/* On-Site / Remote / Hybrid */}
                    <div className="px-0 me-4">
                      <Form.Label className="custm-lble" style={{ color: "#0d6efd" }}>
                        On-Site/Remotely/Hybrid
                      </Form.Label>
                      <Form>
                        {["radio"].map((type) => (
                          <div key={`inline-${type}`} className="mb-2">
                            {[
                              { label: "On-Site", value: "On Site" },
                              { label: "Remotely", value: "remote" },
                              { label: "Hybrid", value: "hybrid" },
                            ].map((opt, i) => (
                              <div key={opt.value}>
                                <Form.Check
                                  inline
                                  label={opt.label}
                                  name="siteremote"
                                  value={opt.value}
                                  type={type}
                                  id={`siteremote-${i}`}
                                  className="labelText2"
                                  onChange={JobHandler}
                                  checked={jobdata?.siteremote === opt.value}
                                />
                              </div>
                            ))}
                          </div>
                        ))}
                      </Form>
                    </div>

                    {/* Job Type */}
                    <div className="px-0">
                      <Form.Label className="custm-lble" style={{ color: "#0d6efd" }}>
                        Job type
                      </Form.Label>
                      <Form>
                        {["radio"].map((type) => (
                          <div key={`inline-${type}`} className="mb-2">
                            {[
                              { label: "Full Time", value: "full time" },
                              { label: "Part Time", value: "part time" },
                            ].map((opt, i) => (
                              <div key={opt.value}>
                                <Form.Check
                                  inline
                                  label={opt.label}
                                  name="jobtype"
                                  value={opt.value}
                                  type={type}
                                  id={`jobtype-${i}`}
                                  className="labelText2"
                                  onChange={JobHandler}
                                  checked={jobdata?.jobtype === opt.value}
                                />
                              </div>
                            ))}
                          </div>
                        ))}
                      </Form>
                    </div>
                  </div>

                  {/* Description */}
                  <div className="px-5">
                    <Form.Label className="custm-lble pb-2">Job Description</Form.Label>
                    <Form.Control
                      onChange={(e) => JobHandler(e)}
                      value={jobdata?.description || ""}
                      name="description"
                      as="textarea"
                      rows={9}
                    />
                    {errors.description && touched.description && (
                      <p className="error_text_color">{errors.description}</p>
                    )}
                  </div>

                  {/* Submit / Cancel */}
                  <div className="d-flex justify-content-end py-3 px-5">
                    <div>
                      <button
                        className="cbtn1"
                        type="button"
                        onClick={() => navigate(`/company-profile/${id}`)}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn-blue-sm pt-2 pb-2 px-3"
                        onClick={(e) => (isUpdateMode ? updateData(e) : PostData(e))}
                      >
                        {props.btn}
                      </button>
                    </div>
                  </div>
                </Col>
              </div>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default OfferJobForm;
